import { FormArray, FormControl, FormGroup } from "@angular/forms"
import {  WMLFieldZeroProps, WMLLabelZeroProps } from "@windmillcode/angular-wml-field"
import { WMLInputZeroComponent, WMLInputZeroProps } from "@windmillcode/angular-wml-input"

export let useFormControlNamesAsFieldVariableNames =(prop:{[k:string]:string})=>{
  return Object.values(prop)
  .map((val)=>{
    return val+"Field"
  })
}

export   let createWMLFormZeroPropsField = (props:GenerateFieldProps<any>)=>{
  let {
    labelValue,
    fieldFormControlName,
    fieldParentForm,
    errorMsgs,
    selfType,
    fieldCustomProps,
    id
  } = props
  let wmlField:WMLFieldZeroProps
  wmlField =  new WMLFieldZeroProps({
    type: "custom",
    custom: {

      selfType: selfType ?? "standalone",
      fieldParentForm,
      fieldFormControlName,
      labelValue,
      fieldCustomCpnt:WMLInputZeroComponent,
      errorMsgs:errorMsgs??{
        required:"global.errorRequired"
      },
      fieldCustomProps:new WMLInputZeroProps({
        ...fieldCustomProps,
        wmlField
      })
    }
  })
  wmlField.view.id = id
  return wmlField
}

export class GenerateFieldProps<F=any> {
  constructor(props:Partial<GenerateFieldProps<F>>={}){
    Object.assign(
      this,
      {
        ...props
      }
    )
  }

  labelValue?:string
  fieldFormControlName:string
  fieldParentForm:FormGroup
  errorMsgs:WMLLabelZeroProps["errorMsgs"] ={
    "required":"global.errorRequired"
  }
  selfType:WMLFieldZeroProps["self"]["type"] ="standalone"
  fieldCustomProps?:F
  id?:string

}

export let resetFormControls =(formGroup: FormGroup | FormArray)=> {
  // Iterate through all the controls in the form group
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);

    if (control instanceof FormGroup) {
      // Recursively reset controls in nested FormGroup
      resetFormControls(control);
    } else if (control instanceof FormArray) {
      // Reset FormArray to its initial state
      control.clear();
      control.markAsPristine()
    } else if (control instanceof FormControl) {
      // Reset FormControl to its initial state
      control.reset();
    }
  });
}

export let createI18nErrorMsgsBasedOnValidations = (prefix:string,val:string,checklist:Array<string>=[])=>{
  let obj = checklist
  .map((errorKey)=>{
    let errorVal = [prefix,val,"error",errorKey].join(".")
    return [errorKey,errorVal]
  })
  let result = Object.fromEntries(obj)
  result["required"] ??= "global.errorRequired"
  result["email"] ??= "global.errorEmail"
  return result
}

export let createFieldString =(field:string)=>{
  return {
    base:field,
    get field(){
      return this.base +"Field"
    },
    get fieldFormControlName(){
      return this.base + 'FormControlName'
    }
  }
}


